import { makeStyles } from '@mui/styles';
import { colors } from '@components/design-system';

export const useStyles = makeStyles(() => ({
    backButton: {
        color: colors.neutral[700],
        marginLeft: '20px',
        height: '30px',
        fontSize: '12.5px',
    },
    icon: {
        marginRight: '5px',
    },
}));
